import { api } from "constants/RotasAPI";
import useFetch from "hooks/useFetch";
import { Page } from "types/dto/Page";
import { toast } from "react-hot-toast";
import { RequestAgendamentoContato } from "types/request/RequestAgendamentoContato";
import { RegistroAgendamentoContatoDTO } from "types/dto/RegistroAgendamentoContatoDTO";

export const useGetAgendamentosContatosRealizados = (request: RequestAgendamentoContato) => {
  const onError = () => {
    toast.error("Erro ao buscar agendamentos");
  };

  const config = {
    staleTime: 1000 * 60 * 5,
    retry: 2,
  };

  return useFetch<Page<RegistroAgendamentoContatoDTO>>({
    key: ["agendamentos-contatos", request],
    url: api.agendamentoContato.getRegistrosAgendamentosContatosPaginados,
    params: request,
    onError,
    config,
  });
};
